const custom_profile_fields = {
    entity_not_exists_with_names: '找不到具有給定名稱的實體：{{names}}',
    invalid_min_max_input: '最小值與最大值輸入無效。',
    invalid_options: '欄位選項無效。',
    invalid_regex_format: '正則表達式格式無效。',
    invalid_address_parts: '地址組成部分無效。',
    invalid_fullname_parts: '全名組成部分無效。',
    name_exists: '已存在具有該名稱的欄位。',
    conflicted_sie_order: '登入體驗的欄位順序值衝突。',
    invalid_name: '欄位名稱無效，只允許字母或數字，區分大小寫。',
    name_conflict_sign_in_identifier: '欄位名稱無效。"{{name}}" 是保留的登入標識符鍵。',
    name_conflict_custom_data: '欄位名稱無效。"{{name}}" 是保留的自訂資料鍵。',
    name_required: '欄位名稱為必填項。',
};
export default Object.freeze(custom_profile_fields);
